import React from "react";
import styles from "./css/ThankYouPage.module.css";
import { useSiteContent } from "../hooks/useSiteContent";
import MetaManager from "./MetaManager";

export default function ThankYouPage() {
  const { content } = useSiteContent();
  const successLinks = Array.isArray(content?.payment?.successLinks) ? content.payment.successLinks : [];
  const contacts = Array.isArray(content?.payment?.contacts) ? content.payment.contacts : [];
  const support = contacts.find((item) => item.url) || null;

  return (
    <div className={styles.wrapper}>
      <MetaManager
        seo={content?.seo?.payment}
        fallbackTitle="Спасибо за оплату — Сверхум"
        fallbackDescription="Платёж принят. Вернитесь в бот или на главную страницу Сверхум."
        fallbackPath="/thank-you"
      />
      <div className={styles.content}>
        <h1 className={styles.title}>Спасибо за оплату</h1>
        <p className={styles.subtitle}>
          Доступ обычно активируется автоматически. Если что-то пошло не так, напишите{" "}
          {support?.url ? (
            <a href={support.url} target="_blank" rel="noreferrer">
              в поддержку
            </a>
          ) : (
            "в поддержку"
          )}
          .
        </p>
        <div className={styles.buttonGroup}>
          {successLinks.length > 0 ? (
            successLinks.map((item) => (
              <a key={`${item.label}-${item.url}`} href={item.url || "/"} className={styles.button}>
                {item.label}
              </a>
            ))
          ) : (
            <>
              <a href="https://vk.com/newchatgpt" className={styles.button}>
                Вернуться в бот
              </a>
              <a href="/" className={styles.button}>
                На главную
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
